<template>
  <div class="page">
    <FacebookLogin/>

    <div class="action-bar my-4">
      <router-link v-if="$store.state.loginStatus===true" v-html='$t("global.next")'
                   to="Install" tag="button" 
                   class="keyloopButton textUppercase" id="loginNext" />
    </div>
  </div>
</template>

<script>
    import { Component, Vue } from 'vue-property-decorator';
    import FacebookLogin from '@/components/FacebookLogin.vue';

    @Component({
        components: {
            FacebookLogin,
        },
    })
    export default class Login extends Vue {}
</script>

<style lang="scss">
  #loginNext {
    width: 252px;
    margin-bottom: 33px;
  }
</style>
